function participationPoolHandleResultSaveResponse(response) {
  var redirectDelay = 10000; //10s
  console.log(response.completionUrl);
  if (!response.completionUrl) {
    // nothing to do here
    return;
  }
  var completionUrl = response.completionUrl;
  contentText = ' \
      <h3> \
      <small>';
      
  if (language == 'turkish') {
    // the topic is different in Turkish
    contentText += 
        '<span id="redirectCountDown">' 
        + (redirectDelay / 1000) 
        +  '</span> '
        + textScreens['subject_pool_redirect'][language][1] 
        + ' '
        + textScreens['subject_pool_redirect'][language][0] 
      + '</small> \
      <br>' 
      + textScreens['subject_pool_redirect'][language][2]
      + ' <a style="color:darkorange" href="' + completionUrl + '">' 
      + textScreens['subject_pool_redirect'][language][3] 
      + '</a>'
      + ' ' + textScreens['subject_pool_redirect'][language]['2-1'];
  } else {
    contentText += textScreens['subject_pool_redirect'][language][0] 
      + ' <span id="redirectCountDown">' 
      + (redirectDelay / 1000) 
      +  '</span> ' 
      + textScreens['subject_pool_redirect'][language][1] 
    + '</small> \
    <br>' 
    + textScreens['subject_pool_redirect'][language][2]
    + ' <a style="color:darkorange" href="' + completionUrl + '">' 
    + textScreens['subject_pool_redirect'][language][3] 
    + '</a>';
  }

  contentText += ' '
      + textScreens['subject_pool_redirect'][language][4] + 
      ' \
      <br> \
      <small>' 
        + textScreens['subject_pool_redirect'][language][5] 
        + '</small> \
    </h3> \
    ';

  var contentDomEl = document.getElementById('content');
  contentDomEl.insertAdjacentHTML('beforeend', contentText);

  scheduleRedirect(completionUrl, redirectDelay);
  decremntCountdown(redirectDelay, 'redirectCountDown');

  function scheduleRedirect(url, delay) {
    setTimeout(function redirectToCompletionUrl() {
      window.location.href = url;
    }, delay);
  }

  function decremntCountdown(redirectDelay, containerId) {
    var remainingDelay = redirectDelay;
    var container = document.getElementById(containerId);

    var interval = window.setInterval(function() {
      remainingDelay = Math.max(remainingDelay - 1000, 0);
      if (remainingDelay === 0 )  {
        clearInterval(interval);
      }
      container.innerText = remainingDelay / 1000;
    }, 1000);
  }
}
